import { useRef, useCallback } from "react";

export const useThrottleFn = (
  fn,
  delay = 300,
  leading = false,
  trailing = true
) => {
  const lastCall = useRef(0);
  const timer = useRef(null);

  const throttledFn = useCallback(
    (...args) => {
      const now = Date.now();
      const shouldCall = leading && lastCall.current === 0;

      if (shouldCall || now - lastCall.current >= delay) {
        fn(...args);
        lastCall.current = now;
        if (timer.current) {
          clearTimeout(timer.current);
          timer.current = null;
        }
      } else if (trailing && !timer.current) {
        timer.current = setTimeout(() => {
          fn(...args);
          lastCall.current = Date.now();
          timer.current = null;
        }, delay - (now - lastCall.current));
      }
    },
    [fn, delay, leading, trailing]
  );

  return throttledFn;
};
